// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class GeneratePdfFromTemplateRequestContentPoint {
    static getAttributeTypeMap() {
        return GeneratePdfFromTemplateRequestContentPoint.attributeTypeMap;
    }
}
GeneratePdfFromTemplateRequestContentPoint.discriminator = undefined;
GeneratePdfFromTemplateRequestContentPoint.additionalProperties = false;
GeneratePdfFromTemplateRequestContentPoint.attributeTypeMap = [
    {
        "name": "x",
        "baseName": "x",
        "type": "number"
    },
    {
        "name": "y",
        "baseName": "y",
        "type": "number"
    },
];
//# sourceMappingURL=generatePdfFromTemplateRequestContentPoint.js.map